var map = {
	"./award__coupon.png": 1009,
	"./coupon-new.png": 1024,
	"./coupon.png": 1008,
	"./facebook.png": 1057,
	"./gift.png": 1038,
	"./google.png": 1058,
	"./kgold-new.png": 1059,
	"./kgold.png": 1060,
	"./score-icon.png": 1015,
	"./uc-new.png": 1025
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1658;